const navs = [
    { name: "labels.tasks", url: "/maintenance/tasks/", icon: "tasks", role: "admin" },
    { name: "labels.programming", url: "/maintenance/programming/", icon: "clipboard-list", role: "admin" },
    { name: "labels.orders", url: "/maintenance/orders/", icon: "newspaper", role: "admin" },
    { name: "labels.incidence", url: "/maintenance/incidence/", icon: "bullhorn", role: "admin" },
]
export default navs